/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramCategoryControllerFindAllQueryResponse } from '../../types/TelegramCategoryControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCategoryFindAll } from '../../methods/telegramCategoryFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCategoryFindAllQueryKey = () => [{ url: '/api/telegram/category' }] as const;

export type TelegramCategoryFindAllQueryKey = ReturnType<typeof telegramCategoryFindAllQueryKey>;

export function telegramCategoryFindAllQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = telegramCategoryFindAllQueryKey();
  return queryOptions<
    TelegramCategoryControllerFindAllQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramCategoryControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCategoryFindAll(config);
    },
  });
}

/**
 * {@link /api/telegram/category}
 */
export function useTelegramCategoryFindAll<
  TData = TelegramCategoryControllerFindAllQueryResponse,
  TQueryData = TelegramCategoryControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramCategoryFindAllQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCategoryControllerFindAllQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCategoryFindAllQueryKey();

  const query = useQuery(
    {
      ...telegramCategoryFindAllQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
